import type { ScanMeta } from '@/ui'

export interface TagScan {
  code: string
  entry: ScanMeta['entry']
}

/** The pack operator's count and end-of-run sacks, kept on the phone until Close run. */
export interface FillDraft {
  pouches_good: number
  pouches_rejected: number
  /** A spot weight below the minimum waits for its pouch to be counted as rejected. */
  pending_reject: boolean
  leftover_g: number | null
  leftover_tag: TagScan | null
  spillage_g: number | null
  spillage_tag: TagScan | null
  sack_type_id: string | null
  /** Filling finished: the close screen opens. */
  finished: boolean
}

export const emptyFill = (): FillDraft => ({
  pouches_good: 0,
  pouches_rejected: 0,
  pending_reject: false,
  leftover_g: null,
  leftover_tag: null,
  spillage_g: null,
  spillage_tag: null,
  sack_type_id: null,
  finished: false,
})

export type FillUpdate = (fn: (d: FillDraft) => FillDraft) => void
